export function FuturesFieldIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M2.55556 4.625C2.34167 4.625 2.16667 4.79375 2.16667 5V11C2.16667 11.2063 2.34167 11.375 2.55556 11.375H13.4444C13.6583 11.375 13.8333 11.2063 13.8333 11V5C13.8333 4.79375 13.6583 4.625 13.4444 4.625H2.55556ZM1 5C1 4.17266 1.69757 3.5 2.55556 3.5H13.4444C14.3024 3.5 15 4.17266 15 5V11C15 11.8273 14.3024 12.5 13.4444 12.5H2.55556C1.69757 12.5 1 11.8273 1 11V5ZM4.88889 6.3125V9.6875C4.88889 9.99922 4.62882 10.25 4.30556 10.25C3.98229 10.25 3.72222 9.99922 3.72222 9.6875V6.3125C3.72222 6.00078 3.98229 5.75 4.30556 5.75C4.62882 5.75 4.88889 6.00078 4.88889 6.3125Z"
        fill="var(--foreground-default, #101010)"
      />
    </svg>
  );
}
